export const loginData = [
  { user: "test", password: "test", name: "Jane"},
  { user: "admin", password: "admin", name: "Jacopo" },
  { user: "user", password: "user", name: "User"}
];
